import {
  faBooksMedical,
  faCircleInfo,
  faHandshakeSimple,
} from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { HeaderNavItem } from '@/app/(main)/_components/sign-in-modal/_types/header.types';
import { beOurPartnerUrl } from '@/utils/consts/partner.consts';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import { setOpenLocationSelectionModal } from '@/store/modal';

export const navItems: HeaderNavItem[] = [
  {
    id: 'Para você',
    normalLabel: 'Para você',
    responsivenessLabel: 'Para você',
    url: null,
    icon: faBooksMedical,
    dataTestId: DataTestIdEnum.HEADER_FOR_YOU_NAVBAR_TITLE,
    subItems: [
      {
        id: 'sub-2',
        label: 'Quero agendar',
        onClick: handleOpenSearchModal,
        dataTestId: DataTestIdEnum.HEADER_I_WANT_TO_ORDER_BUTTON,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'quero agendar' }),
      }, {
        id: 'sub-3',
        label: 'Nossas unidades',
        onClick: () => setOpenLocationSelectionModal(true),
        dataTestId: DataTestIdEnum.HEADER_OUR_BRANCHES_BUTTON,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'nossas unidades' }),
      },
    ],
  },
  {
    id: 'professional',
    normalLabel: 'Para profissionais e clínicas',
    responsivenessLabel: 'Para profissionais',
    dataTestId: DataTestIdEnum.HEADER_PROFESSIONAL_NAVBAR_TITLE,
    url: null,
    icon: faHandshakeSimple,
    subItems: [
      {
        id: 'sub-professional-1',
        label: 'Acessar Sistema do Parceiro',
        url: 'https://parceiro.medprev.app/login',
        target: '_blank',
        dataTestId: DataTestIdEnum.HEADER_PARTNER_SYSTEM_LINK,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'acessar sistema de parceiro' }),

      },
      {
        id: 'sub-professional-2',
        label: 'Seja nosso Parceiro',
        url: beOurPartnerUrl,
        target: '_blank',
        dataTestId: DataTestIdEnum.HEADER_BE_OUR_PARTNER_LINK,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'seja nosso parceiro' }),
      },
    ],
  },
  {
    id: 'medprev',
    normalLabel: 'Sobre a Medprev',
    responsivenessLabel: 'Sobre',
    url: null,
    icon: faCircleInfo,
    dataTestId: DataTestIdEnum.HEADER_ABOUT_MEDPREV_NAVBAR_TITLE,
    subItems: [
      {
        id: 'medprev-01',
        label: 'Sobre nós',
        url: '/sobre/',
        dataTestId: DataTestIdEnum.HEADER_ABOUT_US_LINK,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'sobre nós' }),
      },
      {
        id: 'medprev-02',
        label: 'Preciso de ajuda',
        url: '/preciso-de-ajuda/',
        dataTestId: DataTestIdEnum.HEADER_NEED_HELP_LINK,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'precisa de ajuda' }),
      },
      {
        id: 'medprev-04',
        label: 'Blog',
        url: '/blog/',
        dataTestId: DataTestIdEnum.HEADER_BLOG_LINK,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'blog' }),
      },
      {
        id: 'medprev-05',
        label: 'Trabalhe conosco',
        url: '/trabalhe-conosco/',
        dataTestId: DataTestIdEnum.HEADER_WORK_WITH_US_LINK,
        ['data-analytics-properties']: JSON.stringify({ item_header: 'trabalhe conosco' }),
      },
    ],
  },
];
